import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from "primereact/progressspinner";
import { useState } from "react";
import { formatDateWithTime } from "../../../../shared/utility";
import WipIncomingSubTable2 from "./WipIncomingSubTable2";
import TraceableBarcode from "../../../controls/TraceableBarcode";
import TraceableLotNumber, {
  getInventoryLotTraceType,
} from "../../../controls/TraceableLotNumber";

export default function WipIncomingSubTable1(props) {
  const {
    data,
    loadingRows,
    rowDetails,
    fetchSubRowDetails,
    subRowDetails,
    subLoadingRows,
    openSlideForManufacturedItemDetails,
    onAskReturnIncomingItem,
    incomingSelectedItems,
    setIncomingSelectedItems,
  } = props;

  const [expandedRows, setExpandedRows] = useState(null);

  const onRowExpand = (event) => {
    const rowData = event.data;
    if (!subRowDetails[rowData.unique_id]) {
      fetchSubRowDetails(rowData);
    }
  };

  const allowExpansion = (rowData) => {
    return rowData.pallet_id;
  };

  const bodyItemProductName = (item) => {
    return (
      <div>
        {item.product_name} <br />{" "}
        <span className="font-bold">PLU: {item.plu}</span>
      </div>
    );
  };

  function rowExpansionTemplate(data) {
    return (
      <WipIncomingSubTable2
        data={data}
        loadingRows={subLoadingRows}
        rowDetails={subRowDetails}
      />
    );
  }

  const bodyItemWeight = (item) => {
    return <p>{item.total_weight_in_kg} kg</p>;
  };

  const bodyItemPieces = (item) => {
    return <p>{item.total_pieces} pieces</p>;
  };

  const bodyFormatCreatedDate = (item) => {
    return <p>{formatDateWithTime(item.created_date)}</p>;
  };

  if (loadingRows[data.unique_id]) {
    return <ProgressSpinner style={{ width: "30px", height: "30px" }} />;
  }

  const detail = rowDetails[data.unique_id];
  if (!detail) return null;

  const lotNumberBody = (rowData) => (
    <TraceableLotNumber
      lotNumber={rowData.lot_number}
      traceType={getInventoryLotTraceType(rowData)}
    />
  );

  const serialBody = (rowData) => (
    <TraceableBarcode
      barcode={rowData.barcode}
      displayValue={rowData.serial}
    />
  );

  const singleItemActionTemplate = (rowData) => {
    return (
      <div className="flex">
        <button
          className="ml-2 rounded-md bg-yellow-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-yellow-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-600"
          onClick={() => {
            openSlideForManufacturedItemDetails(
              rowData.manufactured_product_id,
              rowData.pallet_id
            );
          }}
        >
          Info
        </button>
        <button
          className="ml-2 rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
          onClick={() => onAskReturnIncomingItem(rowData)}
        >
          Return
        </button>
      </div>
    );
  };

  return (
    <div>
      <DataTable
        value={rowDetails[data.unique_id]}
        expandedRows={expandedRows}
        onRowToggle={(e) => {
          setExpandedRows(e.data);
        }}
        onRowExpand={onRowExpand}
        rowExpansionTemplate={rowExpansionTemplate}
        dataKey="unique_id"
        tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm receiving-sub-items-table-1"
        cellClassName="py-2 bg-gray-100 border-1-bottom-gray px-2 text-sm inv-sub-item"
        selectionMode="checkbox"
        selection={incomingSelectedItems}
        onSelectionChange={(e) => setIncomingSelectedItems(e.value)}
      >
        <Column
          selectionMode="multiple"
          headerStyle={{ width: "3rem" }}
        ></Column>
        <Column
          header="Product Name"
          body={bodyItemProductName}
          style={{ width: "23%" }}
        />
        <Column
          header="Lot Number"
          body={lotNumberBody}
          style={{ textAlign: "start", width: "10%" }}
        />
        <Column
          header="Serial"
          body={serialBody}
          style={{ textAlign: "start", width: "10%" }}
        />
        <Column
          field="added_by_name"
          header="Added by"
          style={{ textAlign: "start", width: "8%" }}
        />
        <Column
          header="Date added"
          body={bodyFormatCreatedDate}
          style={{ textAlign: "start", width: "12%" }}
        />
        <Column
          header="Total Weight"
          body={bodyItemWeight}
          style={{ width: "7%", textAlign: "right" }}
        />
        <Column
          header="Total Pieces"
          body={bodyItemPieces}
          style={{ width: "10%", textAlign: "right" }}
        />
        <Column body={singleItemActionTemplate} style={{ width: "19%" }} />
        <Column expander={allowExpansion} style={{ width: "6%" }} />
      </DataTable>
    </div>
  );
}
